/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationStatus } from './ApplicationStatus';
import {
    ApplicationStatusFromJSON,
    ApplicationStatusFromJSONTyped,
    ApplicationStatusToJSON,
    ApplicationStatusToJSONTyped,
} from './ApplicationStatus';

/**
 * 
 * @export
 * @interface ApplicationResponse
 */
export interface ApplicationResponse {
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    requireIdPorten?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {ApplicationStatus}
     * @memberof ApplicationResponse
     */
    status?: ApplicationStatus;
}



/**
 * Check if a given object implements the ApplicationResponse interface.
 */
export function instanceOfApplicationResponse(value: object): value is ApplicationResponse {
    return true;
}

export function ApplicationResponseFromJSON(json: any): ApplicationResponse {
    return ApplicationResponseFromJSONTyped(json, false);
}

export function ApplicationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'requireIdPorten': json['requireIdPorten'] == null ? undefined : json['requireIdPorten'],
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'status': json['status'] == null ? undefined : ApplicationStatusFromJSON(json['status']),
    };
}

export function ApplicationResponseToJSON(json: any): ApplicationResponse {
    return ApplicationResponseToJSONTyped(json, false);
}

export function ApplicationResponseToJSONTyped(value?: ApplicationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'requireIdPorten': value['requireIdPorten'],
        'requiresMfa': value['requiresMfa'],
        'status': ApplicationStatusToJSON(value['status']),
    };
}

